import { Link, useNavigate } from "react-router-dom";
import { Product } from "../data/products";
import { useCart } from "../Context/CartContext";
import { useWishlist } from "../Context/WishlistContext";

export default function ProductCard({ product }: { product: Product }) {
  const { addToCart } = useCart();
  const { wishlistIds, toggleWishlist } = useWishlist();
  const navigate = useNavigate();

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (product.variants && product.variants.length > 0) {
      navigate(`/product/${product.id}`);
      return;
    }

    addToCart({ 
      id: product.id, 
      name: product.name, 
      price: product.price.toString(), 
      quantity: 1 
    });
    alert("Added to Cart!");
  };

  const handleWishlist = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(product.id);
  };

  const discount = product.originalPrice 
    ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
    : 0;

  const isWishlisted = wishlistIds.includes(product.id);

  return (
    <Link to={`/product/${product.id}`} className="card" style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: '16px', position: 'relative' }}>
      
      <div 
        onClick={handleWishlist} 
        style={{ position: 'absolute', top: '16px', right: '16px', fontSize: '24px', cursor: 'pointer', zIndex: 10, color: isWishlisted ? '#d00000' : 'var(--text-muted)' }}>
        {isWishlisted ? '♥' : '♡'}
      </div>

      <img src={product.imageUrl} alt={product.name} style={{ width: '100%', aspectRatio: '1/1', objectFit: 'contain', marginBottom: '12px' }} />
      
      <h3 style={{ fontSize: '14px', margin: '0 0 8px 0', paddingRight: '24px' }}>{product.name}</h3>
      
      <div style={{ marginBottom: '8px', fontSize: '14px', color: 'var(--text-secondary)' }}>
        <span style={{ background: '#388e3c', color: 'white', padding: '2px 6px', borderRadius: '4px', marginRight: '8px' }}>
          {product.rating} ★
        </span>
        ({product.reviewsCount})
      </div>

      <div style={{ marginBottom: '16px' }}>
        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>₹{product.price}</span>
        {product.originalPrice && (
          <span style={{ display: 'inline-block', marginLeft: '8px' }}>
            <span style={{ textDecoration: 'line-through', color: 'var(--text-muted)' }}>₹{product.originalPrice}</span>
            <span style={{ color: '#388e3c', marginLeft: '8px', fontSize: '14px' }}>{discount}% off</span>
          </span>
        )}
      </div>

      <button className="btn-primary" style={{ marginTop: 'auto', width: '100%' }} onClick={handleAddToCart}>
        Add to Cart
      </button>
    </Link>
  );
}
